import { observer } from 'mobx-react-lite'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { TaxExtensionProgressionActionsContainer } from '@/features/jobs/details/components/JobProgressionCard/TaxExtensionProgressionActions/TaxExtensionProgressionActionsContainer'
import { CompleteJobProgressionActions } from '@/features/jobs/details/components/JobProgressionCard/CompleteJobProgressionActions'

export interface CompleteJobProgressionActionsContainerProps {
  vm: JobProgressionViewModel
}

export const CompleteJobProgressionActionsContainer = observer(
  function CompleteJobProgressionActionsContainer({
    vm,
  }: CompleteJobProgressionActionsContainerProps) {
    return (
      <CompleteJobProgressionActions
        isAnyExtensionFlowAvailable={vm.isAnyExtensionFlowAvailable}
        onCompleteJob={vm.closeJob}
        extensionActions={
          vm.isAnyExtensionFlowAvailable && (
            <TaxExtensionProgressionActionsContainer vm={vm} isSecondary />
          )
        }
      />
    )
  },
)
